import Vue from 'vue'
import CustomStates from '../../utils/customstates'

let RB = window.RB

const state = new CustomStates({
  name: 'silicone',
  manifestStates: RB.layout.manifest.states
})

const getters = {}

const actions = {
  stepIsCompleted ({ dispatch, commit, state }, stateName) {
    if (typeof state.visited[stateName] === 'undefined') {
      commit('stepIsVisited', stateName)
    }
    if (typeof state.completed[stateName] === 'undefined') {
      commit('stepIsCompleted', stateName)
    }

    dispatch('visitPreviousStates', stateName)
  },
  stepIsVisited ({ dispatch, commit, state }, stateName) {
    if (typeof state.visited[stateName] === 'undefined') {
      commit('stepIsVisited', stateName)
    }

    dispatch('visitPreviousStates', stateName)
  },
  stepIsDirty ({ dispatch, commit, state }, stateName) {
    if (typeof state.isDirty[stateName] === 'undefined') {
      commit('stepIsDirty', stateName)
    }

    dispatch('visitPreviousStates', stateName)
  },
  visitPreviousStates ({ commit, state }, stateName) {
    let currentIndex = state.states.findIndex(state2 => state2.name === stateName)
    for (let i = 0; i < currentIndex; i++) {
      let obj = state.states[i]
      commit('stepIsVisited', obj.name)
    }
  },
  checkVisibleStates ({ commit, state }, printStyle) {
    let changes = state.checkVisibleStates(printStyle)

    for (let change of changes) {
      commit('setHidden', change)
      commit('setCompleted', {
        routeName: change.state.name,
        value: change.hidden
      })
    }
  },
  setAllDirty ({ commit, state }) {
    for (let i = 0; i < state.states.length; i++) {
      let obj = state.states[i]
      commit('stepIsDirty', obj.name)
    }
  }
}

const mutations = {
  setCompleted (state, payload) {
    let { routeName, value } = payload

    Vue.set(state.completed, routeName, value)
  },
  stepIsCompleted (state, routeName) {
    Vue.set(state.completed, routeName, true)
  },
  stepIsVisited (state, routeName) {
    Vue.set(state.visited, routeName, true)
  },
  stepIsDirty (state, routeName) {
    Vue.set(state.isDirty, routeName, true)
  },
  reset (state, payload) {
    state.reset()
  },
  setHidden (state, payload) {
    let customStateIndex = state.states.findIndex(x => x.name === payload.state.name)
    if (customStateIndex !== -1) {
      state.states[customStateIndex].hidden = payload.hidden
    } else {
      console.log(`Couldn't find state '${payload.state.name}'`)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
